import { createComponent } from '@helpers/admin';
import { P, RenderMarkdown } from '@template/components';

export const Paragraph = createComponent({
  label: 'Paragraph',
  component: (props) => (
    <P as='div' {...props}>
      <RenderMarkdown>{props.children}</RenderMarkdown>
    </P>
  ),
  fields: {
    children: {
      label: 'Text',
      type: 'markdown',
    },
    $color: {
      label: 'Color',
      type: 'select',
      options: [
        {
          label: 'Standard',
          value: 'default',
        },
        {
          label: 'Light',
          value: 'light',
        },
        {
          label: 'Lightest',
          value: 'lightest',
        },
      ],
    },
    $textAlign: {
      label: 'Text Align',
      type: 'select',
      options: [
        {
          label: 'Left',
          value: 'left',
        },
        {
          label: 'Center',
          value: 'center',
        },
        {
          label: 'Right',
          value: 'right',
        },
        {
          label: 'Justify',
          value: 'justify',
        },
      ],
    },
    $small: {
      label: 'Small',
      type: 'boolean',
    },
  },
});
